var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54169 6.95837H8.95835V24.0417H5.54169V6.95837ZM20.9167 6.95837H22.625V24.0417H20.9167V6.95837ZM14.0834 6.95837H19.2084V24.0417H14.0834V6.95837ZM10.6667 6.95837H12.375V24.0417H10.6667V6.95837ZM24.3334 6.95837H29.4584V24.0417H24.3334V6.95837Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83335 3.54167H10.6667V0.125H3.83335C1.94906 0.125 0.416687 1.65737 0.416687 3.54167V10.375H3.83335V3.54167ZM3.83335 30.875H10.6667V27.4583H3.83335V20.625H0.416687V27.4583C0.416687 29.3426 1.94906 30.875 3.83335 30.875ZM31.1667 0.125H24.3334V3.54167H31.1667V10.375H34.5834V3.54167C34.5834 1.65737 33.051 0.125 31.1667 0.125ZM31.1667 27.4583H24.3334V30.875H31.1667C33.051 30.875 34.5834 29.3426 34.5834 27.4583V20.625H31.1667V27.4583Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.3a231cd2c7247650b4e49a4bee7c6165.svg";
export { ForwardRef as ReactComponent };